import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import {devConfig, profile} from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal request table view.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Get current user parameter

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // Data table view
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            id: 'bankTable', // ID for the data table
                            scroll: true, // Enable scrolling
                            height: screen.width < 500 ? 400 : 0, // Set height based on screen width
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: 'Editar', // Tooltip text
                                    hidden: (!devConfig.getPermAction('editPlayerAccount', 'Add')),
                                    template: function (obj) {
                                        // Template for rendering the column
                                        return "<span class='webix_icon wxi-close edit'></span>";
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'Id', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Bank', // Column ID
                                    header: _('Banco'), // Column header with localization
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'BankAccountNumber', // Column ID
                                    header: _('Número Cuenta Bancaria'), // Column header with localization
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'BankCodeInterbank', // Column ID
                                    header: _('Código Interbancario'), // Column header with localization
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'BankType', // Column ID
                                    header: _('Tipo Cuenta'), // Column header with localization
                                    options: [
                                        // Options for the combo editor
                                        { id: '1', value: _('Ahorros') },
                                        { id: '2', value: _('Corriente') },
                                        { id: '3', value: _('Tarjeta') },
                                        { id: 'EVP', value: _('EVP') },
                                        { id: 'CPF', value: _('CPF') },
                                        { id: 'PHONE', value: _('PHONE') },
                                        { id: 'EMAIL', value: _('EMAIL') },
                                    ],
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Estado'), // Column header with localization
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activo') },
                                        { id: 'I', value: _('Inactivo') },
                                    ],
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'RegisterDate', // Column ID
                                    header: _('Fecha Registro'), // Column header with localization
                                    width: 200, // Column width
                                    sort: 'date', // Sorting type
                                    format: dateFormat, // Date format
                                    editor: 'date', // Editor type
                                }
                            ],
                            onClick: {
                                edit: function (euv, id) {
                                    // Event handler for edit button click
                                    $$('editwin').show(); // Show edit window
                                },
                            },
                            on: {
                                onBeforeLoad: function () {
                                    // Event before loading data
                                    this.showOverlay(
                                        // Show loading overlay
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    // Event after loading data
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                // Event when the table is ready
                                if (!this.count()) {
                                    // Check if there are no data
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        // Show no data overlay
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            editable: true, // Enable editing
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                            // Data source URL
                            url: devConfig.geturlApi() + 'es/Client/GetClientBankAccounts?PlayerId=' + cur_user + '',
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and binds events.
     * @param {Object} grid - The data table instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('bankTable'); // Get the data table instance
        const cur_user = this.getParam('user', true); // Get current user parameter
        var url = grid.data.url; // Store the data URL
        var filter = ''; // Initialize filter variable
        var popup = webix.ui({
            // Create edit popup window
            view: 'window',
            id: 'editwin',
            head: 'Editar', // Window header
            position: 'center', // Position of the window
            modal: true, // Modal window
            body: {
                view: 'form', // Form view
                id: 'editform', // Form ID
                elements: [
                    {
                        view: 'text', // Text input for Bank
                        label: _('Banco'), // Label with localization
                        name: 'Bank', // Input name
                        readonly: true, // Make it read-only
                        disabled: true, // Disable input
                    },
                    {
                        view: 'text', // Text input for Bank Account Number
                        label: _('Número Cuenta Bancaria'), // Label with localization
                        name: 'BankAccountNumber', // Input name
                        readonly: true, // Make it read-only
                        disabled: true, // Disable input
                    },
                    {
                        view: 'text', // Text input for Bank Code Interbank
                        label: _('Código Interbancario'), // Label with localization
                        name: 'BankCodeInterbank', // Input name
                        readonly: true, // Make it read-only
                        disabled: true, // Disable input
                    },
                    {
                        view: 'combo', // Combo input for State
                        label: _('Estado'), // Label with localization
                        name: 'State', // Input name
                        options: [
                            // Options for the combo editor
                            { id: 'A', value: _('Activo') },
                            { id: 'I', value: _('Inactivo') },
                        ],
                    },
                    {
                        cols: [
                            // Button layout
                            {
                                view: 'button', // Cancel button
                                value: _('Cancelar'), // Button text with localization
                                click: function () {
                                    // Click event handler
                                    this.getTopParentView().hide(); // Hide the popup
                                },
                            },
                            {
                                view: 'button', // Save button
                                type: 'form', // Button type
                                value: _('Guardar'), // Button text with localization
                                click: function ($e) {
                                    // Click event handler
                                    var values = $$('editform').getValues(); // Get form values
                                    webix // AJAX request to save the bank account
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'Client/SaveClientBankAccount',
                                            '{"PlayerId":' +
                                                cur_user +
                                                ', "Id":' +
                                                values.Id +
                                                ',"State":"' +
                                                values.State +
                                                '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var json = JSON.parse(text); // Parse response JSON
                                                    if (json.HasError) { // Check for errors in response
                                                        if (json.CodeError != 110012) {
                                                            webix.message({
                                                                title: _("¡Error!"),
                                                                type: "alert-error",
                                                                text: json.AlertMessage // Display error message from response
                                                            });
                                                        } else {
                                                            webix.message({
                                                                title: _("¡Error!"),
                                                                type: "alert-error",
                                                                text: "Ocurrio un error inesperado, intenta nuevamente" // Display error message from response
                                                            });
                                                        }
                                                    } else {
                                                    webix.message({
                                                        // Show success message
                                                        text: _('Cuenta Bancaria editada satisfactoriamente'),
                                                        title: _('¡Exito!'),
                                                        type: 'alert-warning',
                                                    });
                                                    }
                                                    grid.load(
                                                        // Reload the grid data
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter,
                                                    );
                                                },
                                            },
                                        );
                                    this.getTopParentView().hide(); // Hide the popup
                                },
                            },
                        ],
                    },
                ],
            },
        });
        var popupAdd; // Popup for adding new entries
        this.on(this.app, 'bankAccountReport:filter', (filterData) => {
            // Event for filtering bank accounts
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter data
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check if value is not an object and not empty
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check if value is not null
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'MaxCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'MinCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&PlayerId=' + cur_user; // Add current user to filter string
            grid.clearAll(); // Clear the grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event after sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event on item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        grid.attachEvent('onBeforeEditStart', function (id) {
            // Event before editing starts
            var item = this.getItem(id); // Get the item being edited
            console.log(item);
            if (id.column == 'State') {
                // Check if editing State column
                var options = this.getColumnConfig('Action').collection; // Get action options
                if (item.State == 'A') {
                    // If state is Active
                    options.remove('A'); // Remove Active option
                } else if (item.State == 'I') {
                    // If state is Inactive
                    options.remove('I'); // Remove Inactive option
                } else {
                    return false; // Prevent editing if state is neither
                }
                console.log(id);
            }
        });
        grid.attachEvent('onAfterEditStop', function (state, editor, ignoreUpdate) {
            // Event after editing stops
            console.log(state);
            var item = this.getItem(editor.row); // Get edited item
            console.log(item);
            if (state.value != state.old) {
                // Check if value has changed
                if (state.value == 'A') {
                    // If new state is Active
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json', // Set content type
                        })
                        .post(
                            devConfig.geturlApi() + 'Client/AllowWithdrawalRequests',
                            '{ "Id":' + item.Id + '}', // Send request to allow withdrawal
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.message('Error! '); // Show error message
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    item.State = 'P'; // Update item state to Pending
                                    webix.message('Cell value was changed'); // Show message
                                },
                            },
                        );
                }
                if (state.value == 'P') {
                    // If new state is Pending
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json', // Set content type
                        })
                        .post(
                            devConfig.geturlApi() + 'Client/PayWithdrawalRequests',
                            '{ "Id":' + item.Id + '}', // Send request to pay withdrawal
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.message('Error! '); // Show error message
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    item.State = 'I'; // Update item state to Inactive
                                    webix.message('Cell value was changed'); // Show message
                                },
                            },
                        );
                }
                if (state.value == 'E') {
                    // If new state is Canceled
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json', // Set content type
                        })
                        .post(
                            devConfig.geturlApi() + 'Client/CancelClientRequests',
                            '{ "Id":' + item.Id + '}', // Send request to cancel withdrawal
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.message('Error! '); // Show error message
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    item.State = 'E'; // Update item state to Canceled
                                    webix.message('Cell value was changed'); // Show message
                                },
                            },
                        );
                }
            }
        });
        this.on(this.app, 'player:select', (id) => {
            // Event when a player is selected
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id, // Load data for selected player
            );
        });
        $$('editform').bind($$('bankTable')); // Bind form to data table

        // Event listener for adding new entries
        this.on(this.app, "bankAccountReport:addCard", item => {
            popupAdd.show(); // Show the add popup
            $$("addform").clearValidation(); // Clear validation on the form
        });

        // Popup configuration for adding new entries
        popupAdd = webix.ui({
            view: "window", // Window view
            id: "AddAdjustments", // Popup ID
            height: 700, // Popup height
            head: {
                view: "toolbar", // Toolbar for the popup
                cols: [
                    {view: "label", label: _("Registrar tarjeta Stradacarte"), align: "center"}, // Title label
                    {view: "icon", icon: "wxi-close", click: function () { // Close button
                            this.getTopParentView().hide(); // Hide the popup
                        }}
                ]
            },
            position: "center", // Center the popup
            modal: true, // Make the popup modal
            body: {
                view: "form", id: "addform", elements: [ // Form for adding new entries
                    {view: "text", label: _("ID CARD:"), attributes: {type: "number", min:  0},
                        id: "IdCard", name: "IdCard", labelWidth: 150, labelPosition: "top", required: true}, // Source currency field
                    {view: "text", label: _("Numero de tarjeta:"), placeholder: "XXXX",  attributes: { maxlength: 4 },
                        pattern: { mask: "####", allow: /[0-9]/g },
                        id: "CardDigit", name: "CardDigit", labelWidth: 150, labelPosition: "top", required: true}, // Destination currency field
                    {

                        cols: [
                            {
                                view: "button", value: _("Cancelar"), click: function () { // Cancel button
                                    this.getTopParentView().hide(); // Hide the popup
                                    $$('addform').setValues($$('addform').getCleanValues()); // Reset form values
                                }
                            },
                            {
                                view: "button", type: "form", class: "approve", value: _("Guardar"), height: 45, click: function ($e) { // Add conversion button
                                    var values = $$("addform").getValues(); // Get form values
                                    if (!$$("addform").validate()) { // Validate form
                                        webix.message({
                                            title: _("¡Error!"),
                                            type: "alert-error",
                                            text: _("Completa los campos...") // Error message for incomplete fields
                                        });
                                        return;
                                    }
                                    webix.ajax().headers({
                                        "Content-type": "application/json" // Set content type for AJAX request
                                    }).post(devConfig.geturlApi() + "Client/CreateStradacarteCard", '{"IdCard":"' + values.IdCard + '", "CardDigit":"' + values.CardDigit + '", "UserId":' + cur_user + '}', {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message("Error! "); // Error message for AJAX request failure
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var json = JSON.parse(text); // Parse response JSON
                                            if (json.HasError) { // Check for errors in response
                                                if (json.CodeError != 110012) {
                                                    webix.message({
                                                        title: _("¡Error!"),
                                                        type: "alert-error",
                                                        text: json.AlertMessage // Display error message from response
                                                    });
                                                } else {
                                                    webix.message({
                                                        title: _("¡Error!"),
                                                        type: "alert-error",
                                                        text: "Ocurrio un error inesperado, intenta nuevamente" // Display error message from response
                                                    });
                                                }
                                            } else {
                                                webix.message("Tarjeta registrada exitosamente"); // Success message
                                                grid.clearAll(); // Clear grid data
                                                grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter); // Reload grid data
                                            }
                                        }
                                    });
                                    $$('addform').setValues($$('addform').getCleanValues()); // Reset form values
                                    this.getTopParentView().hide(); // Hide the popup
                                }
                            }
                        ]
                    }
                ],
                elementsConfig: {
                    on: {
                        onChange: function () {
                            this.validate(); // Validate form on change
                        }
                    }
                },
                rules: {
                    IdCard: webix.rules.isNotEmpty, // Validation rule for source currency
                    CardDigit: webix.rules.isNotEmpty // Validation rule for destination currency
                }
            }
        });
    }
}

// FILE DOCUMENTED
